import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { InstanceType } from "src/app/shared/types/instance-types";

@Injectable({
  providedIn: "root",
})
export class InstanceService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/instance/${endpoint}`;
  }

  getAllInstances(): Observable<any> {
    return this.http.get<any>(this.apiUrlWithEndpoint(""));
  }

  getInstance(instanceId: number): Observable<InstanceType> {
    return this.http.get<any>(this.apiUrlWithEndpoint(`${instanceId}`));
  }

  addInstance(contractId: any): Observable<any> {
    return this.http.post<any>(
      this.apiUrlWithEndpoint(`contract/${contractId}`),
      {},
    );
  }

  updateInstance(instanceId: number, instanceData: any): Observable<any> {
    return this.http.put<any>(
      this.apiUrlWithEndpoint(`${instanceId}`),
      instanceData,
    );
  }

  deleteInstance(contractId: number): Observable<any> {
    return this.http.delete<any>(
      this.apiUrlWithEndpoint(`contract/${contractId}`),
    );
  }

  checkIfDomainExists(value: string) {
    return this.http.get<any>(
      this.apiUrlWithEndpoint(`domain/check?domainName=${value}`),
    );
  }
}
